import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=38181984&lang=scss&scoped=true"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38181984"]])

export default __exports__